'use client';

import { useEffect } from 'react';
import { reportFrontendError } from '@/lib/frontend-error-reporter';
import { isChunkLoadError, reloadOnceForChunkError } from '@/lib/chunk-error';

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const chunkFailure = isChunkLoadError(error);

  useEffect(() => {
    reportFrontendError(error, { source: 'react-boundary', digest: error.digest });
    // 배포로 청크가 사라진 경우다. 리렌더로는 풀리지 않으니 문서를 새로 받아온다.
    reloadOnceForChunkError(error);
  }, [error]);

  return (
    <html lang="ko">
      <body style={{ fontFamily: 'sans-serif', margin: 0 }}>
        <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', textAlign: 'center', padding: 24 }}>
          <div>
            <h1>페이지를 불러오지 못했습니다.</h1>
            {/* 청크가 사라진 경우 reset() 은 의미가 없다 — 다시 렌더해도 파일은 여전히 없다. */}
            {chunkFailure ? (
              <button type="button" onClick={() => window.location.reload()}>
                새로고침
              </button>
            ) : (
              <button type="button" onClick={reset}>
                다시 시도
              </button>
            )}
          </div>
        </main>
      </body>
    </html>
  );
}
